import React from 'react';
import { Box, Typography, Button } from '@mui/material';

// Test: utiliser une photo "portrait" plus contrastée (N&B) en Hero.
const HERO_IMAGE = '/img/facebook/487351636_1604428843831856_6926337699856559596_n.jpg';
const YOUTUBE_PLAYLIST_URL =
  'https://www.youtube.com/playlist?list=PLSlapqa_gjHp31Jnljif4W0QXTgS25Ozo';

export function Hero({ title = 'Patrick Noah', tagline }) {
  const parts = String(title).trim().split(/\s+/);
  const lastWord = parts[parts.length - 1] || '';
  const firstWords = parts.slice(0, -1).join(' ');
  const isNoah = lastWord.toLowerCase() === 'noah';
  const noahText = isNoah ? 'NOAH' : lastWord.toUpperCase();
  const patrickText = isNoah ? (firstWords || 'Patrick') : title;

  return (
    <Box
      component="header"
      sx={{
        position: 'relative',
        // Mobile : hauteur = viewport moins la barre (~56px), pas 88vh en plus → évite bandes vides haut/bas.
        // Desktop : grand hero inchangé.
        minHeight: { xs: 'calc(100dvh - 56px)', md: '92vh' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        overflow: 'hidden',
        bgcolor: 'primary.dark',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `url(${HERO_IMAGE})`,
          // xs : cover = pas de « letterboxing » (bandes bleues) en haut/bas sur mobile portrait.
          backgroundSize: { xs: 'cover', md: '130% auto' },
          backgroundRepeat: 'no-repeat',
          // Cadrage vertical (guitare + mains) + léger décalage horizontal.
          backgroundPosition: { xs: '42% 35%', md: '42% 30%' },
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          // Un peu plus d'opacité pour garder une bonne lisibilité,
          // sans assombrir autant qu'avant.
          background:
            // Très léger ajustement: on laisse l'image respirer (qualité basse),
            // tout en conservant une lisibilité correcte du texte.
            'linear-gradient(to bottom, rgba(15,24,37,0.07) 0%, rgba(15,24,37,0.05) 50%, rgba(15,24,37,0.16) 100%)',
        }}
      />
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          px: 2,
          py: { xs: 3, sm: 5, md: 6 },
          ml: '4px',
          maxWidth: { xs: '100%', md: 920 },
          width: '100%',
          textAlign: 'left',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          minHeight: { xs: 'calc(100dvh - 56px)', md: '92vh' },
        }}
      >
        {isNoah ? (
          <>
            <Typography
              component="div"
              sx={{
                color: '#ff3333',
                fontSize: { xs: '3.1rem', sm: '4.0rem', md: '5.0rem' },
                fontWeight: 700,
                letterSpacing: '-0.04em',
                lineHeight: 0.95,
                mb: 0.35,
                textShadow: '0 2px 20px rgba(0,0,0,0.35)',
              }}
            >
              {patrickText}
            </Typography>
            <Typography
              variant="h1"
              sx={{
                color: '#ff3333',
                fontSize: { xs: '4.5rem', sm: '6rem', md: '7.5rem' },
                fontWeight: 800,
                letterSpacing: '-0.06em',
                lineHeight: 0.85,
                mb: 2,
                textShadow: '0 2px 26px rgba(0,0,0,0.35)',
              }}
            >
              {noahText}
            </Typography>
          </>
        ) : (
          <Typography
            component="h1"
            sx={{
              color: '#ff3333',
              fontSize: { xs: '4.5rem', sm: '6rem', md: '7.5rem' },
              fontWeight: 800,
              letterSpacing: '-0.06em',
              mb: 2,
              lineHeight: 0.85,
              textShadow: '0 2px 26px rgba(0,0,0,0.35)',
            }}
          >
            {title}
          </Typography>
        )}
        {tagline && (
          <Typography
            variant="body1"
            sx={{
              color: 'rgba(255,255,255,0.96)',
              maxWidth: 600,
              fontSize: { xs: '1.08rem', sm: '1.2rem', md: '1.35rem' },
              lineHeight: 1.6,
              fontWeight: 700, // rendu plus lisible sur photo basse qualité
              textShadow: '0 3px 18px rgba(0,0,0,0.42)',
            }}
          >
            {tagline}
          </Typography>
        )}
        <Box sx={{ mt: 2 }}>
          <Button
            variant="contained"
            component="a"
            href={YOUTUBE_PLAYLIST_URL}
            target="_blank"
            rel="noreferrer"
            sx={{
              borderRadius: 999,
              fontWeight: 900,
              px: 3,
              py: 1.2,
              boxShadow: '0 18px 50px rgba(0,0,0,0.20)',
              background: 'rgba(255, 51, 51, 0.95)',
              '&:hover': {
                background: 'rgba(255, 51, 51, 1)',
                boxShadow: '0 26px 60px rgba(0,0,0,0.26)',
              },
            }}
          >
            Écouter sur YouTube
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default Hero;
